import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../redux/modalSlice';

import './Modal.css';

const Modal = () => {
  const {dialogModal} = useSelector((state) => state.modal);

  const dispatch = useDispatch();
  return (
    <aside className='custom-modal-container'>
      <div className='custom-modal'>
        <h4>{dialogModal.activeObject.title}</h4>
        <div className='custom-btn-container'>
          {/** Message Dialog */}
          {!(dialogModal.activeObject && (dialogModal.activeObject.okCallBack || dialogModal.activeObject.okCallBack)) &&
            <button
              type='button'
              className='btn confirm-btn'
              onClick={() => {
                dispatch(closeModal());
              }}
            >
              Ok
            </button>}
          {/** Confirm dialog */}
          {dialogModal.activeObject && (dialogModal.activeObject.okCallBack || dialogModal.activeObject.okCallBack) &&
          <>
            <button
              type='button'
              className='btn confirm-btn'
              onClick={() => {
                dispatch(closeModal());
                if (dialogModal.activeObject.okCallBack){
                  dialogModal.activeObject.okCallBack(dialogModal.activeObject)
                }
                else{
                  console.error("dialogModal::okCallBack() was not set")
                };
              }}
            >
              confirm
            </button>
            <button
              type='button'
              className='btn clear-btn'
              onClick={() => {
                dispatch(closeModal());
                if (dialogModal.activeObject.cancelCallBack){
                  dialogModal.activeObject.cancelCallBack(dialogModal.activeObject)
                }
                else{
                  console.error("dialogModal::cancelCallBack() was not set")
                };
              }}
            >
              cancel
            </button>
          </>}
        </div>
      </div>
    </aside>
  );
};
export default Modal;
